import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const TrademarkRegistrationIndia = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />
      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Trademark Registration in India
      </div>
      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        Trademark registration under the Trademark Act, 1999, protects the
        uniqueness of a brand name or logo, preventing unauthorized use and
        safeguarding years of effort invested in establishing a market identity.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Legal Definition */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Legal Definition
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
                marginBottom: isMobile ? "5px" : "10px",
              }}
            ></div>
          </div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            A trademark, as defined under the Trademark Act, 1999, includes words,
            phrases, symbols, or designs that distinguish the goods or services of
            one entity from others, granting exclusive ownership rights and
            prohibiting unauthorized use.
          </p>

          {/* Duration Rules */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Duration Rules
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Unlike patents, which expire after 20 years, a trademark registration
            lasts for 10 years but can be renewed indefinitely, provided the
            renewal process is completed within one year before expiry.
          </p>

          {/* Application Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Application Process
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Logo registration can be applied for online, with the process taking
            4-6 months. The "TM" symbol can be used post-application, while
            validation of original ownership involves multiple checks, including
            support for unconventional marks like sounds.
          </p>

          {/* Registration Requirements */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registration Requirements
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Applicants must provide details of the brand name, logo, symbol, or
            slogan, the date of first use, owner information (including names and
            addresses of all members for companies), an authorization form
            (TM-48), and applicable fees. MSME/Start-up recognition offers a 50%
            fee rebate for eligible entities.
          </p>

          {/* Registry Operations */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registry Operations
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The Trademark Registry, established in 1940 and governed by the 1999
            Act, operates from its head office in Mumbai with branches in Delhi,
            Ahmedabad, Chennai, and Kolkata. It verifies compliance with the Act
            before registering a mark.
          </p>

          {/* Trademark Selection */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Trademark Selection
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Choose a unique, distinctive mark representing your company, selecting
            from classes 1-34 (goods) or 35-45 (services). Conduct a public search
            on the Government website to avoid conflicts with existing trademarks.
          </p>

          {/* Application Filing */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Application Filing
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            File using Form TM-1 for a single class (Rs. 3,500 fee) or Form TM-A
            for multiple classes/series/collective trademarks (Rs. 9,000 for
            e-filing or Rs. 10,000 physically for big enterprises; Rs. 4,500 or
            Rs. 5,000 for small enterprises). Online filing confirms instantly;
            physical filing may take 15-20 days.
          </p>

          {/* Application Status */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Application Status
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Upon confirmation, an allotment number is issued, allowing use of the
            "TM" symbol. Approval results in a registration certificate valid in
            India, without international protection.
          </p>

          {/* Mark Categories */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Mark Categories
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Registrable marks include word marks, service labels, logos, symbols,
            shapes, series brands, collective trademarks, certification marks,
            geographical indicators, pattern marks, sound scores, color marks, and
            three-dimensional marks.
          </p>

          {/* Asset Classification */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Asset Classification
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            A registered trademark is an intangible asset, tradable, franchisable,
            or commercially exploitable, recognized in accounting for tax purposes
            with depreciation deductions.
          </p>

          {/* Legal Safeguards */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Legal Safeguards
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Owners can pursue legal action against unauthorized use, with the "R"
            symbol indicating registered status, enabling infringement claims,
            while the "C" symbol denotes copyright over creative works.
          </p>

          {/* Search Procedures */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Search Procedures
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Conduct a trademark search via the Indian Trademark Registry database
            or third-party portals to ensure uniqueness, reducing objections
            during registration.
          </p>

          {/* Class Structure */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Class Structure
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Goods and services are divided into 45 classes, with 34 for products
            and 11 for services, requiring accurate classification during
            application.
          </p>

          {/* Renewal Guidelines */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Renewal Guidelines
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Renewal must occur within one year before the 10-year validity
            expires, ensuring continuous protection under the Act.
          </p>

          {/* Concluding Notes */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Concluding Notes
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Trademark registration in India offers a robust mechanism to protect
            brand identity, requiring careful selection, filing, and renewal to
            maintain legal standing and prevent infringement.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TrademarkRegistrationIndia;